import React, { useState, useEffect, useCallback, useRef } from "react";
import { Table, Pagination, Select, Spin } from "antd";
// import { cloneDeep, get, map , filter} from "lodash";
import { CaretDownOutlined } from "@ant-design/icons";
import classNames from "classnames";
import "./table.scss";
import HealthemSpinner from "@components/healthemSpinner/healthemSpinner";
import { find, isEmpty, map, noop } from "lodash";
import { ClearFilters, ColFilters, FilterIcon, formatFilterDataForApi, getDropdownFilters } from "@components/filters/colFilters";
import { useDurableStore } from "@stores/useDurableStore";
import { useDropdowns } from "@utils/customHooks";

const { Option } = Select;

const rowsPerPageArray: any[] = [5, 10, 15, 20, 25, 30, 35, 40, 45, 50];

type TableProps = {
  condition?: boolean | undefined;
  dependencyProps?: any;
  handleFetchData: any;
  className: any;
  columns: any;
  rowSelectionNeeded?: boolean | undefined;
  loading?: boolean;
  perPageCount?: number;
  columnOriginalList?: any;
  dependencyPropsForPage1?: any;
  scrollProp?: any;
  rowSelectionType?: any;
  rowKey?: any;
  handleRowSelection ?: any 
};

const TableWithDynamicPagination = ({
  perPageCount = 5,
  loading = false,
  condition = true,
  dependencyProps = [],
  handleFetchData,
  className,
  columns,
  rowSelectionNeeded = false,
  columnOriginalList,
  dependencyPropsForPage1,
  scrollProp = undefined,
  rowSelectionType = "check",
  rowKey,
  handleRowSelection
}: TableProps) => {
  // Local States for table
  const [data, setData] = useState<any[]>([]);
  const [isLoading, setLoading] = useState(false);
  const [filteredInfo, setFilteredInfo] = useState({});
  const [tableParams, setTableParams] = useState<any>({
    pagination: {
      current: 1,
      pageSize: perPageCount ? perPageCount : 5,
    },
  });
  const filterDropdowns = useDurableStore((state) => state.filterDropdowns);
  const setFilterDropdowns = useDurableStore((state) => state.setFilterDropdowns);

  // refs
  const inputref = useRef<any>(null);
  const { getOptions } = useDropdowns();

  // useEffect to fetch the drop downs related to column filters
  useEffect(() => {
    console.log("TableWithDynamicPagination, usEffect");
    // dropdownFilters.current.push(...getDropdownFilters({ colData: columnOriginalList, filterDropdowns: filterDropdowns }));

    // if (!dropdownFilters.current.every((value: string) => Object.keys(filterDropdowns).includes(value))) {
    //   const promises: any[] = [];
    //   dropdownFilters.current.forEach((filter: any) => {
    //     promises.push(memberDetailsService.fetchAttributeDropdown(filter));
    //   });
    //   const result = forkJoin(...promises);
    //   const _filterDropdowns: any = { ...filterDropdowns };
    //   result.subscribe({
    //     next: (response: any) => {
    //       response.forEach((res: any, index: number) => {
    //         res.data.data.data.forEach((val: any) => {
    //           val.text = val.label;
    //         });
    //         _filterDropdowns[dropdownFilters.current[index]] = res.data.data.data;
    //       });
    //       setFilterDropdowns(_filterDropdowns);
    //     },
    //     error: (error) => {
    //       console.log(error);
    //     },
    //   });
    // }
    getOptions(getDropdownFilters({ colData: columnOriginalList }));
  }, [columnOriginalList, filterDropdowns, setFilterDropdowns]);

  // columns with column filters
  let newColumns = map(columns, (item) => {
    if (find(columnOriginalList, { dataIndex: item.dataIndex })?.type) {
      return {
        ...item,
        filterDropdown: ({ confirm, visible }: any) => {
          return (
            <ColFilters
              item={find(columnOriginalList, { dataIndex: item.dataIndex })}
              inputref={inputref}
              confirm={confirm}
              visible={visible}
              getTableData={(filters: any) => {
                setTableParams({
                  ...tableParams,
                  pagination: {
                    ...tableParams?.pagination,
                    current: 1,
                  },
                });
              }}
              filteredInfo={filteredInfo}
              setFilteredInfo={setFilteredInfo}
              // resetFilterPage={resetFilterPage}
              filterDropdowns={filterDropdowns}
              columns={columnOriginalList}
            />
          );
        },
        filterIcon: () => <FilterIcon filteredInfo={filteredInfo} item={find(columnOriginalList, { dataIndex: item.dataIndex })} />,
        onFilter: (value: any, record: any) => (record[item.dataIndex] ? record[item.dataIndex].toString().toLowerCase().includes(value.toLowerCase()) : ""),
        onFilterDropdownOpenChange: (visible: any) => {
          if (visible) {
            setTimeout(() => inputref.current?.select(), 100);
          }
        },
      };
    } else {
      return {
        ...item,
      };
    }
  });

  // fetch Data for the table
  const fetchData = useCallback(async () => {
    console.log("TableWithDynamicPagination, fetchData", dependencyPropsForPage1);
    if (condition) {
      setLoading(true);

      const calcPageNo = !isEmpty(dependencyPropsForPage1) && previousState !== dependencyPropsForPage1 ? 1 : tableParams?.pagination?.current;
      const funcCall = new Promise((resolve, reject) => {
        const _data = handleFetchData({
          pageNo: calcPageNo - 1,
          pageSize: tableParams?.pagination?.pageSize,
          sortBy: tableParams?.column?.dataIndex,
          sortType: tableParams?.order === "ascend" ? "ASC" : tableParams?.order === "descend" ? "DESC" : tableParams?.order,
          filters: formatFilterDataForApi(filteredInfo),
        });

        resolve(_data);
      });
      funcCall
        .then((_data: any) => {
          setData(_data?.data);
          setLoading(false);
          setTableParams({
            ...tableParams,
            pagination: {
              ...tableParams.pagination,
              total: _data?.totalCount,
              current: calcPageNo,
            },
          });
        })
        .catch(() => {
          setLoading(false);
        });
    }
  }, [tableParams?.pagination?.current, dependencyPropsForPage1, tableParams?.pagination?.pageSize, tableParams?.field, tableParams?.order, filteredInfo, ...dependencyProps]);

  useEffect(() => {
    console.log("TableWithDynamicPagination.useEffect2");
    fetchData();
  }, [fetchData]);

  const handleTableChange = (pagination: any, filters: any = tableParams.filters, sorter: any = tableParams.sorter) => {
    console.log("TableWithDynamicPagination.handleTableChange", pagination);
    setTableParams({
      pagination: {
        ...tableParams?.pagination,
        ...pagination,
        current: 1,
      },
      filters,
      ...sorter,
    });

    // `dataSource` is useless since `pageSize` changed
    if (pagination.pageSize !== tableParams.pagination?.pageSize) {
      setData([]);
    }
  };

  const handlePageChange = (newPage: any) => {
    console.log("TableWithDynamicPagination, handlePageChange");
    setTableParams({
      ...tableParams,
      pagination: {
        ...tableParams?.pagination,
        current: newPage,
      },
    });
  };

  const tableClassNames = classNames("ui-new-generic-table", className);

  const usePrevious = (value: { receiveAmount: any; sendAmount: any } | undefined) => {
    console.log("TableWithDynamicPagination, usePrevious");
    const ref: any = useRef();
    useEffect(() => {
      ref.current = value;
    });
    return ref.current;
  };

  const previousState = usePrevious(dependencyPropsForPage1);

  // useEffect(() => {
  //   console.log("TableWithDynamicPagination, useEffect3")
  //   if (!isEmpty(dependencyPropsForPage1)) {
  //     if (previousState !== dependencyPropsForPage1 && tableParams?.pagination?.current !== 1) {
  //       setTableParams({
  //         ...tableParams,
  //         pagination: {
  //           ...tableParams?.pagination,
  //           current: 1,
  //         },
  //       });
  //     } else if (previousState !== dependencyPropsForPage1 && tableParams?.pagination?.current === 1) {

  //       fetchData();
  //     }
  //   }
  // }, [dependencyPropsForPage1]);

  return (
    <>
      <ClearFilters filteredInfo={filteredInfo} setFilteredInfo={setFilteredInfo} getFilteredTableData={noop} />
      <Table
        className={tableClassNames}
        showSorterTooltip={{
          placement: "bottom",
          title: "Click to change sort order",
        }}
        columns={newColumns}
        dataSource={[...data]}
        rowSelection={
          rowSelectionNeeded
            ? rowSelectionType === "radio"
              ? {
                  type: "radio",
                  columnWidth: 48,
                  onSelect: (selectedRow) => handleRowSelection( selectedRow),
                }
              : {}
            : undefined
        }
        pagination={false}
        bordered
        rowKey={rowKey}
        loading={{ spinning: isLoading || loading, indicator: <HealthemSpinner /> }}
        onChange={handleTableChange}
        id="member-table"
        scroll={scrollProp ? scrollProp : { y: window.innerHeight - 360 }}
      />
      <Spin spinning={isLoading || loading} indicator={<></>}>

      {data?.length > 0 && (
        <div className="pagination ui-table-pagination">
          <div>
            Show
            <Select
              defaultValue={tableParams?.pagination?.pageSize}
              style={{ width: 64, margin: "8px 8px" }}
              onChange={(e) => handleTableChange({ ...tableParams?.pagination, pageSize: e })}
              suffixIcon={<CaretDownOutlined />}
            >
              {rowsPerPageArray.map((val) => (
                <Option key={val} value={val}>
                  {val}
                </Option>
              ))}
            </Select>
            rows per page
          </div>
          {data?.length > 0 && (
            <Pagination
              total={tableParams?.pagination?.total}
              showTotal={(total: any, range: any) => (
                <>
                  <span style={{ color: "#091e42" }}>
                    {tableParams?.pagination?.pageSize * tableParams?.pagination?.current - (tableParams?.pagination?.pageSize - 1)} -{" "}
                    {tableParams?.pagination?.pageSize * tableParams?.pagination?.current > data?.length
                      ? data?.length + tableParams?.pagination?.pageSize * tableParams?.pagination?.current - (tableParams?.pagination?.pageSize - 1) - 1
                      : tableParams?.pagination?.pageSize * tableParams?.pagination?.current +
                        tableParams?.pagination?.pageSize * tableParams?.pagination?.current -
                        (tableParams?.pagination?.pageSize - 1) -
                        1}
                  </span>
                  <span> of {tableParams?.pagination?.total}</span>
                </>
              )}
              key={tableParams?.pagination?.pageSize}
              defaultPageSize={tableParams?.pagination?.pageSize}
              defaultCurrent={tableParams?.pagination?.current}
              current={tableParams?.pagination?.current}
              showSizeChanger={false}
              onChange={(e: any) => {
                handlePageChange(e);
              }}
            />
          )}
        </div>
      )}
      </Spin>
    </>
  );
};

export default TableWithDynamicPagination;
